<script>
	import { DataTable, ToolbarSearch, ToolbarContent } from "carbon-components-svelte";
	import { config } from './configs/authors-2022.js'
	import { onMount } from 'svelte'
	import Papa from 'papaparse'
	import { searchTable } from './lib/search.js'
	let data = [];
	let error = {};

	let search = "";

	onMount(async () => {
		Papa.parse(config.url, {
			download: true,
			header: true,
			complete: function (results) {
				data = results.data
				data.map((entry, index) => {
					entry.id = index
				})
				// console.log(data)
			},
			error: function (err) {
				error = err
				console.log(err)
			}
		})
	})
</script>

<main>
	{#await data}
		<p>...waiting</p>
	{:then data}
		<DataTable 
			zebra
			sortable
			title={config.title != "" && config.title }
			description={config.description != "" && config.description}
			rows={searchTable(search, data, config)}
			headers={config.headers}
		>
			<ToolbarContent>
				<ToolbarSearch persistent bind:value={search} />
			</ToolbarContent>
		</DataTable>
	{:catch error}
		<p style="color: red">{error.message}</p>
	{/await}
</main>
<div data-iframe-height=""></div>
<style>
</style>